import { useState, useEffect,useCallback } from 'react'
import { SidebarLayoutNew } from "../components/sidebar-layout-new"; 
import { Heading } from '../components/heading' 
import {  ArrowPathIcon  } from "@heroicons/react/20/solid";
import { Footer } from "../components/footer";
import { BreadcrumbsNew } from "../components/breadcrumbs";
import { Fragment } from "react/jsx-runtime";
import config from '../config.js'
import { PageInfo } from '../components/page-info';
import { Loader } from '../components/loader';
import {    Fieldset,Field,ErrorMessage, Label } from '../components/fieldset'
import { Button } from '../components/button'
import { useAlert } from "../components/customAlert";
import { useNavigate } from 'react-router-dom'; 
const breadcrumbs_link = [{ name: "Adwords Sync", href: "#", current: true }];
export default function AdwordsSync() {
 
  const [error, setError] = useState('');
  const [accounts, setAccounts] = useState([]);
  const [selected, setSelected] = useState("");
  const [loading, setLoading]           = useState(false);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const { showAlert } = useAlert();
  const navigate = useNavigate();

  
  const handleMccSubmit = async () => {
    
    navigate('../adwords-connect?type=exist')
  
};

const handleSubmitNotMcc = () => {
  const oauthUrl = `${config.apiPath}adwords-link/adsConnect.php`;

  const popup = window.open(
    oauthUrl,
    "google_oauth_popup",
    "width=500,height=600"
  );

  if (!popup || popup.closed || typeof popup.closed === "undefined") {
    setError("Popup blocked. Please allow popups.");
  }
};

useEffect(() => {
  const handleMessage = (event) => {
    if (event.data?.event === "ads_connected") {
 
      showAlert("Your adwords account linked with us.", "Status Update", "success", 3000);
      navigate('../adwords-connect?type=new');
    }
  };

  window.addEventListener("message", handleMessage);

  return () => window.removeEventListener("message", handleMessage);
}, []);
 

   
    const page_info = `We connect securely to your Google Ads account to access campaign and ad group performance data.
This includes impressions, clicks, conversions, and cost metrics for better insight.
Your data is used only to provide reports and optimization suggestions.
Access is granted via Google’s secure OAuth2 system, and you can revoke it anytime.
We do not make changes to your ads or access billing information.`;
    return (
      <Fragment>
        <SidebarLayoutNew selected_menu="title-test">
          <BreadcrumbsNew pages={breadcrumbs_link} />
          <div className="flex w-full items-center gap-3 rounded-lg !pl-0 px-2 py-2.5 text-left text-base/4 font-medium text-zinc-950 sm:py-2 sm:text-sm/4 *:data-[slot=icon]:size-6 *:data-[slot=icon]:shrink-0 *:data-[slot=icon]:fill-zinc-500 sm:*:data-[slot=icon]:size-5 *:last:data-[slot=icon]:ml-auto *:last:data-[slot=icon]:size-5 sm:*:last:data-[slot=icon]:size-4 *:data-[slot=avatar]:-m-0.5 *:data-[slot=avatar]:size-7 sm:*:data-[slot=avatar]:size-6 data-hover:bg-zinc-950/5 data-hover:*:data-[slot=icon]:fill-zinc-950 data-active:bg-zinc-950/5 data-active:*:data-[slot=icon]:fill-zinc-950 data-current:*:data-[slot=icon]:fill-zinc-950 dark:text-white dark:*:data-[slot=icon]:fill-zinc-400 dark:data-hover:bg-white/5 dark:data-hover:*:data-[slot=icon]:fill-white dark:data-active:bg-white/5 dark:data-active:*:data-[slot=icon]:fill-white dark:data-current:*:data-[slot=icon]:fill-white">
           
            <ArrowPathIcon  className="!size-8" />
            <Heading className="w-full">Adwords Sync</Heading>
          </div>
          <PageInfo info={page_info} />
  
        <div className="w-full flex items-center justify-center">
        
        
    <div className="flex space-x-4">

      {/* ACCOUNT DROPDOWN */}
      
      {/* MCC BUTTON */}
      <div className="flex justify-center">
        <Button
          type="button"
          onClick={handleMccSubmit}
          className="px-5 py-2 rounded-md"
        >
          Existing Account(MCC)
        </Button>
      </div>

      {/* NOT MCC BUTTON */}
      <div className="flex justify-center">
        <Button
          type="button"
          onClick={handleSubmitNotMcc}
          className="px-5 py-2 rounded-md"
        >
          New Account(Not in MCC)
        </Button>
      </div>

    </div>
      </div> 
 
        </SidebarLayoutNew>
        <Footer />
      </Fragment>
    );

   
} 